import { createObservableDataAction, IAction, ICreateActionContext } from '@msdyn365-commerce/core';
import { retailAction } from '@msdyn365-commerce/retail-proxy';

// TODO: Update these imports to match your generated proxy output.
// The generator creates inputs for your IController methods.
import { addToCartAsyncInput } from '../../../actions/DataActionExtension.g';
import { ILobasCartStagingHandoffConfig } from '../lobas-cart-staging-handoff.props.autogenerated';

export interface ICartStagingHandoffActionInput {
    intentId: string;
    cartId: string;
}

const getIntentId = (ctx: ICreateActionContext, paramName: string): string => {
    const raw = ctx.requestContext?.url?.requestUrl?.search || '';
    const sp = new URLSearchParams(raw.startsWith('?') ? raw : `?${raw}`);
    return (sp.get(paramName) || '').trim();
};

const getCartIdFromCookie = (ctx: ICreateActionContext): string => {
    // Consent gated in Commerce cookie API
    const cookies = ctx.requestContext.cookies;
    if (!cookies.isConsentGiven()) {
        throw new Error('Cookie consent not given');
    }

    const cartCookie = cookies.getCartCookie(); // returns cart id string (often "t:<id>" internally handled by SDK)
    if (!cartCookie) {
        throw new Error('No active cart cookie found');
    }

    return cartCookie;
};

export default createObservableDataAction({
    id: 'CartStagingHandoff',
    action: <IAction<string>>retailAction,
    input: (ctx: ICreateActionContext<ILobasCartStagingHandoffConfig>) => {
        const stagingParamName = (ctx.config?.intentQueryParam as string) || 'stagingId';
        const stagingId = getIntentId(ctx, stagingParamName);
        if (!stagingId) {
            throw new Error(`Missing query param: ${stagingParamName}`);
        }

        const cartId = getCartIdFromCookie(ctx);

        // createApplyCartIntentInput signature depends on your controller method name.
        // You want to pass (intentId, cartId).
        return addToCartAsyncInput(stagingId, cartId);
    }
});
